module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Medium.98df4612.eot";